let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cC6Kz")).then(() => parcelRequire('5Oem9'));